export default "__VITE_ASSET__38e1eed4__"